import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const IdCard = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M23 6H19.825C19.412 4.838 18.3 4 17 4H15C13.7 4 12.588 4.838 12.175 6H9C6.237 6 4 8.238 4 11V23C4 25.762 6.237 28 9 28H23C25.762 28 28 25.762 28 23V11C28 8.238 25.762 6 23 6ZM14 7C14 6.45 14.45 6 15 6H17C17.55 6 18 6.45 18 7V9C18 9.55 17.55 10 17 10H15C14.45 10 14 9.55 14 9V7ZM26 23C26 24.65 24.65 26 23 26H9C7.35 26 6 24.65 6 23V11C6 9.35 7.35 8 9 8H12V9C12 10.65 13.35 12 15 12H17C18.65 12 20 10.65 20 9V8H23C24.65 8 26 9.35 26 11V23Z" />
		<path d="M23 22H19C18.45 22 18 21.55 18 21C18 20.45 18.45 20 19 20H23C23.55 20 24 20.45 24 21C24 21.55 23.55 22 23 22Z" />
		<path d="M23 18H19C18.45 18 18 17.55 18 17C18 16.45 18.45 16 19 16H23C23.55 16 24 16.45 24 17C24 17.55 23.55 18 23 18Z" />
		<path d="M12 24C9.8 24 8 21.762 8 19C8 16.238 9.8 14 12 14C14.2 14 16 16.238 16 19C16 21.762 14.2 24 12 24ZM12 16C10.912 16 10 17.375 10 19C10 20.625 10.912 22 12 22C13.088 22 14 20.625 14 19C14 17.375 13.088 16 12 16Z" />
	</svg>
);

export default IdCard;
